import React from "react";

import { isTruthy } from "../../utils/isTruthy";

import { AnalyticCard } from "./AnalyticCard";
import { MetricCardEmpty } from "./MetricCardEmpty";
import { MetricCardError } from "./MetricCardError";
import { MetricCardLoading } from "./MetricCardLoading";
import { MetricCardNoData } from "./MetricCardNoData";

export function MetricCard({
  title,
  tooltip,
  value,
  isLoading,
  error,
  periodContent,
  isEmpty,
  hasNoData,
  isSelected,
  dataTestId,
}: {
  title: string;
  tooltip?: string;
  value: string;
  isLoading?: boolean;
  error?: unknown;
  periodContent?: React.ReactNode;
  isEmpty?: boolean;
  hasNoData?: boolean;
  isSelected?: boolean;
  dataTestId: string;
}) {
  if (isLoading) {
    return <MetricCardLoading data-testid={dataTestId} />;
  }

  if (error) {
    return <MetricCardError title={title} tooltip={tooltip} />;
  }

  if (isEmpty) {
    return <MetricCardEmpty title={title} tooltip={tooltip} />;
  }

  if (hasNoData) {
    return <MetricCardNoData title={title} tooltip={tooltip} />;
  }

  return (
    <AnalyticCard
      dataTestId={dataTestId}
      isLoading={isLoading}
      isSelected={isSelected}
      title={title}
      titleJustifyBetween={false}
      tooltip={tooltip}
      variant="compact"
    >
      <div className="flex flex-col gap-0 justify-between items-start w-full h-full min-w-0">
        <div className="flex flex-col gap-0 w-full min-w-0">
          <p
            className="heading-4 truncate w-full min-w-0"
            data-testid={`${dataTestId}-value`}
          >
            {value}
          </p>
        </div>
        {isTruthy(periodContent) && (
          <div className="w-full min-w-0" data-testid={`${dataTestId}-period`}>
            {periodContent}
          </div>
        )}
      </div>
    </AnalyticCard>
  );
}
